module.exports = __webpack_public_path__ + "img/kitsu.6de9c2b9.png";